import DataLayer from "./DataLayer";

export default ({ type, message }) => {
    if (!type) {
        return;
    }

    DataLayer.track({
        event: "error",
        error: {
            type,
            message,
        },
    });
};
